import request from '../utils/Request';
import { Methods, NotificationType } from '../config';
import { downloadFile } from '../utils/download';
import addNotification from '../utils/addNotification';
import dayjs from 'dayjs';
import { ResponseType } from '../config/responetype';

const baseURL = 'simpletask';

const simpletaskService = {
  getSimpleTasks: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/simpleTasks`,
    });
  },

  getTasks: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/tasks`,
      data,
    });
  },

  checkOneResourcePerDay: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/task/checkOneResourcePerDay`,
      data,
    });
  },

  getGridTasks: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/gridtasks`,
      data,
    });
  },

  getTaskById: (simpleTaskId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(simpleTaskId)}`,
    });
  },

  getMyTodoPriority: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/mytodo/priority`,
    });
  },

  getMyTodoStatus: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/mytodo/status`,
    });
  },

  updateStatus: (data) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/status`,
      data,
    });
  },

  updateRespPerson: (data) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/respPerson`,
      data,
    });
  },

  createSimpleTask: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      formData: true,
      data,
    });
  },

  updateSimpleTask: (data, simpleTaskId) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/${encodeURIComponent(simpleTaskId)}`,
      formData: true,
      data,
    });
  },

  deleteSimpleTask: (simpleTaskId) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(simpleTaskId)}`,
    });
  },

  addRespPersonToList: (data, simpleTaskId) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/respPersonList/${encodeURIComponent(simpleTaskId)}`,
      data,
    });
  },

  deleteRespPersonFromList: (personListId) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/respPersonList/${encodeURIComponent(personListId)}`,
    });
  },

  updateRespPersonList: (data, respPersonListId) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/updateRespPersonList/${encodeURIComponent(respPersonListId)}`,
      data,
    });
  },

  createTaskReport: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/taskReport`,
      formData: true,
      data,
    });
  },

  getExcelTemplate: async () => {
    const excelFromServer = await request({
      responseType: 'blob',
      resource: `${baseURL}/template/exceltemplate`,
    });
    return downloadFile(excelFromServer, `Feladatok_template-${dayjs().format('YYYYMMDD_HHmm')}.xlsx`);
  },

  getExcelData: async () => {
    const excelFromServer = await request({
      responseType: 'blob',
      resource: `${baseURL}/data/exceldata`,
    });
    return downloadFile(excelFromServer, `Feladatok-${dayjs().format('YYYYMMDD_HHmm')}.xlsx`);
  },

  importExcel: async (files, userId) => {
    const formData = new FormData();

    for (const file of files) {
      formData.append('files', file);
    }
    formData.append('userId', userId);

    const resp = await request({
      method: Methods.POST,
      resource: `${baseURL}/import/excelimport`,
      formData: true,
      data: formData,
      responseType: 'blob',
    });

    if (resp?.type === ResponseType.xlsx) {
      addNotification({
        content: 'Az import sikertelen!',
        type: NotificationType.ERROR,
      });

      downloadFile(resp, `ERR_${files[0].name}`);
      return Promise.reject(new Error('Error in uploaded file!'));
    }

    const reader = new FileReader();
    reader.readAsText(resp);
    reader.onload = () => {
      const jsonData = JSON.parse(reader.result);
      if (jsonData?.error?.message) {
        return addNotification({
          content: jsonData.error.message,
          type: NotificationType.ERROR,
        });
      }
      return jsonData.data;
    };
  },

  addOrRemoveRespPerson: (simpleTaskId, userId) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/task/addOrRemoveRespPerson/${encodeURIComponent(simpleTaskId)}/${encodeURIComponent(userId)}`,
    });
  },
};

export default simpletaskService;
